import React from 'react';
import LiveKitVoiceAssistant from '../components/voice/LiveKitVoiceAssistant';
import { getApiUrl } from '../utils/apiConfig';

/**
 * Voice Assistant Page
 * Standalone page for the LiveKit voice assistant
 */
function VoiceAssistant() {
  // fetchLiveKitToken will use production URL by default (proxied through nginx)
  // You can pass a custom tokenUrl if needed for development/testing
  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <LiveKitVoiceAssistant />
    </div>
  );
}

export default VoiceAssistant;

